import { api } from "../api/api";
import { Dropdown } from "../core/form/Dropdown";
import { useApi } from "../core/hooks/useApi";
import { DataContext, useDataContext } from "../core/hooks/useData";
import { ref } from "../types";

export function TagEditor(props: {
	dbObj: {
		meta?: {
			tags?: string[],
		}
	},
}) {
	const tags: ref = useApi({
		request: () => api.ref_get({
			ids: ["tags"],
		}),
	}, [])!;

	const data = useDataContext({
		initialValue: props.dbObj,
	})

	if (!tags) return null;
	if (!props.dbObj.meta) props.dbObj.meta = {};

	return (
		<DataContext.Provider value={data}>
			<Dropdown
				items={tags.data.rows}
				style={{backgroundColor: "transparent", border: "solid rgba(255,255,255,0.1) 1px"}}
				multiSelect={true}
				getValue={(item) => item["0"]}
				getDisplay={(item) => <div className="tag" style={{backgroundColor: item["1"], borderColor: item["1"], color: item["2"]}}>{item["0"]}</div>}
				prop="meta.tags"
			/>
		</DataContext.Provider>
	);
}